import { useMemo } from "react";
import {
  createBrowserRouter,
  type RouteObject,
  RouterProvider
} from "react-router-dom";

import { type AppRouteSettings } from "../routes";

import { CurrentUserBootstrap } from "./CurrentUserBootstrap";
import { RouteGuard } from "./RouteGuard";

export type Props = {
  routes: AppRouteSettings[];
};

function mapRoutesToRouter(routeSetting: AppRouteSettings): RouteObject {
  const element = routeSetting.element ? (
    <RouteGuard validator={routeSetting.accessValidator}>
      {routeSetting.element}
    </RouteGuard>
  ) : (
    routeSetting.element
  );

  if (routeSetting.children?.length) {
    return {
      ...routeSetting,
      element,
      children: routeSetting.children.map(mapRoutesToRouter)
    };
  }

  return {
    ...routeSetting,
    element
  };
}

export function RouterAppGuard(props: Props): JSX.Element {
  // The router is built once. Access enforcement lives inside each RouteGuard,
  // which reads auth/workspace-context reactively. This avoids rebuilding the
  // browser router on every context switch (which forced full remounts,
  // repeated requests and lost navigation state).
  const router = useMemo(
    () => createBrowserRouter(props.routes.map(mapRoutesToRouter)),
    [props.routes]
  );
  return (
    <>
      <CurrentUserBootstrap />
      <RouterProvider router={router} />
    </>
  );
}
